import { ActionButton, List, ListItem } from '@icarros/ids-react';
import React, { useRef, useState } from 'react';

import { ReactComponent as AdIcon } from '../../../../../assets/rebranding/icons/anuncio.svg';
import { CardOptionsWrapper } from './style';
import { Deactivate } from '../Modal/';
import { Droplist } from '../../../../components/Droplist';
import { pushSellerPFDashboardEvent } from '../../../../../utils/pushToDataLayer';

interface CardOptionsProps {
  editId: number;
  linkToAd?: string;
  showEdit?: boolean;
  showDelete?: boolean;
  showHelp?: boolean;
  showDeactivate?: boolean;
}

export function CardOptions({
  editId,
  linkToAd,
  showDelete = false,
  showHelp = false,
  showDeactivate = false,
}: Readonly<CardOptionsProps>): JSX.Element {
  const wrapperRef = useRef<HTMLDivElement>(null);
  const [isOpen, setIsOpen] = useState<boolean | undefined>(undefined);
  const [modalOpen, setModalOpen] = useState(false);
  const hasNoOptionAvailable = !(!!editId || linkToAd || showDelete || showHelp);

  if (hasNoOptionAvailable) {
    return <></>;
  }

  return (
    <CardOptionsWrapper ref={wrapperRef}>
      <ActionButton
        iconName="itaufonts_configuracoes"
        text="opções"
        variant="secondary"
        weight="medium"
        onClick={() => {
          pushSellerPFDashboardEvent('opções');
          setIsOpen(prevState => !prevState);
        }}
      />
      {isOpen && (
        <Droplist handleCloseModal={setIsOpen} wrapperRef={wrapperRef}>
          <List>
            {linkToAd ? (
              <ListItem
                avatarIconElement={<AdIcon />}
                avatarVariant="icon"
                label="exibir anúncio"
                variant="action"
                hasLine={false}
                actionOnClick={() => {
                  pushSellerPFDashboardEvent('> - exibir anúncio');
                  window.open(linkToAd, '_blank');
                }}
              />
            ) : (
              <></>
            )}
            {showDelete ? (
              <ListItem
                avatarIcon="itaufonts_excluir"
                avatarVariant="icon"
                label="excluir anúncio"
                variant="action"
                hasLine={false}
                actionOnClick={() => {
                  pushSellerPFDashboardEvent('> - excluir anúncio');
                  setIsOpen(false);
                  setModalOpen(true);
                }}
              />
            ) : (
              <></>
            )}
            {showDeactivate ? (
              <ListItem
                avatarIcon="itaufonts_switch"
                avatarVariant="icon"
                label="desativar anúncio"
                variant="action"
                hasLine={false}
                actionOnClick={() => {
                  pushSellerPFDashboardEvent('> - desativar anúncio');
                  setIsOpen(false);
                  setModalOpen(true);
                }}
              />
            ) : (
              <></>
            )}
            {showHelp ? (
              <ListItem
                avatarIcon="itaufonts_ajuda"
                avatarVariant="icon"
                label="preciso de ajuda"
                variant="action"
                hasLine={false}
                actionOnClick={() => {
                  pushSellerPFDashboardEvent('> - preciso de ajuda');
                  window.open('https://icarros.zendesk.com/hc/pt-br', '_blank', 'noopener');
                }}
              />
            ) : (
              <></>
            )}
          </List>
        </Droplist>
      )}

      {showDeactivate && modalOpen && (
        <Deactivate modalOpen={modalOpen} setModalOpen={setModalOpen} adId={editId} />
      )}
      {showDelete && modalOpen && (
        <Deactivate modalOpen={modalOpen} setModalOpen={setModalOpen} adId={editId} isDelete />
      )}
    </CardOptionsWrapper>
  );
}
